import placeholderArticle from "../img/placeholder-article.svg";

/**
 * Branche un fallback sur toutes les <img> d'un conteneur (contenu d'article
 * rendu par TipTap, etc.). Les images cassées (404, URL morte) basculent sur
 * un placeholder de marque au lieu de l'icône cassée du navigateur.
 *
 * Écouteur en phase capture car l'événement `error` des <img> ne remonte pas.
 * Couvre aussi les images déjà cassées au moment du branchement (balayage initial).
 *
 * @param {HTMLElement} root      conteneur (ex. editor.view.dom)
 * @param {string}      fallback  source de secours
 * @returns {() => void}          fonction de nettoyage
 */
export const attachImageFallback = (root, fallback = placeholderArticle) => {
    if (!root) {
        return () => {};
    }

    const applyFallback = (img) => {
        if (
            img
            && img.tagName === "IMG"
            && img.dataset.fallbackApplied !== "1"
            && !img.currentSrc.endsWith(fallback)
        ) {
            img.dataset.fallbackApplied = "1";
            img.src = fallback;
        }
    };

    const handler = (event) => applyFallback(event.target);
    root.addEventListener("error", handler, true);

    // Images déjà chargées-cassées avant le branchement de l'écouteur.
    const frame = window.requestAnimationFrame(() => {
        root.querySelectorAll("img").forEach((img) => {
            if (img.complete && img.naturalWidth === 0) {
                applyFallback(img);
            }
        });
    });

    return () => {
        window.cancelAnimationFrame(frame);
        root.removeEventListener("error", handler, true);
    };
};

export default attachImageFallback;
